const packageName = "@atlassian/editor-plugin-ai";
const packageVersion = "25.22.0";
export function getPackageInfo() {
  return {
    packageName,
    packageVersion
  };
}